import moment from 'moment';
import { schema } from 'normalizr';

import createResource from './createResource';
import fileUploadsResource from './fileUploadsResource';
import patientsResource from './patientsResource';
import { Broadcast } from './types';
import uploadsResource from './uploadsResource';
import usersResource from './usersResource';

const broadcastsResource = createResource<Broadcast>({
  key: 'broadcasts',
  url: '/broadcasts',
  lookups: {
    createdBy: usersResource,
    fileUpload: fileUploadsResource,
    upload: uploadsResource,
    patients: {
      ...patientsResource,
      schema: new schema.Array(patientsResource.schema),
    },
    // TODO add missing lookups (or wait for `react-query` and fetch lookups using BE logic)
  },
  processStrategy: (data) => ({
    ...data,
    sendAt: data.sendAt || moment(),
    _timing: data.sendAt ? 'later' : 'now',
    // eslint-disable-next-line
    _patientContactPreferences: !data.shouldUseUploadedContacts
      ? 'luma'
      : data.shouldUsePrimaryContactOnly
      ? 'filePrimary'
      : 'file',
  }),
});

const getInitialValues = () =>
  ({
    fileUpload: undefined,
    title: '',
    message: '',
    secureChat: false,
    sendAt: moment().add(1, 'hours') as any,
    messageOverrides: [],
    upload: undefined,
    // extended
    _timing: 'now',
    _patientContactPreferences: 'file',
  } as Partial<Broadcast>);

export default {
  ...broadcastsResource,
  getInitialValues,
};
